var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.height < 100)?_c('div',{ref:"container",staticClass:"vue-scrollbar__scrollbar-vertical",on:{"click":_vm.jump}},[_c('div',{ref:"scrollbar",class:'scrollbar' + ( _vm.dragging || _vm.draggingFromParent ? '' : ' vue-scrollbar-transition'),style:({
      height: _vm.height+'%',
      top: _vm.scrolling + '%'
    }),on:{"touchstart":_vm.startDrag,"mousedown":_vm.startDrag}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }